const Info = ({ width = 20, height = 20, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      color={color}
      {...props}
    >
      <path
        d="M10.6702 18.3332C6.06775 18.3332 2.33691 14.6023 2.33691 9.99984C2.33691 5.39734 6.06775 1.6665 10.6702 1.6665C15.2727 1.6665 19.0036 5.39734 19.0036 9.99984C19.0036 14.6023 15.2727 18.3332 10.6702 18.3332ZM9.83691 9.1665V14.1665H11.5036V9.1665H9.83691ZM9.83691 5.83317V7.49984H11.5036V5.83317H9.83691Z"
        fill={color}
      />
    </svg>
  )
}

export default Info
